var React = require('react');

function RadioButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.00033 0.666016C4.40033 0.666016 0.666992 4.39935 0.666992 8.99935C0.666992 13.5993 4.40033 17.3327 9.00033 17.3327C13.6003 17.3327 17.3337 13.5993 17.3337 8.99935C17.3337 4.39935 13.6003 0.666016 9.00033 0.666016ZM9.00033 15.666C5.31699 15.666 2.33366 12.6827 2.33366 8.99935C2.33366 5.31602 5.31699 2.33268 9.00033 2.33268C12.6837 2.33268 15.667 5.31602 15.667 8.99935C15.667 12.6827 12.6837 15.666 9.00033 15.666Z","fill":"#1A237E"}));
}

RadioButton.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = RadioButton;

RadioButton.default = RadioButton;
